<template>
    <div class="enters">
        <div class="lr">
            <el-row :gutter="10">
                <el-col :span="12">
                    <a 
                    class="item zfcg"
                    @click="login">
                        政府采购项目
                    </a>
                </el-col>
                <el-col :span="12">
                    <a 
                    class="item gcjs"
                    @click="login">
                        工程建设项目
                    </a>
                </el-col>
            </el-row>
            <el-row :gutter="10" style="margin-top:8px">
                <el-col :span="12">
                    <a 
                    class="item jtxm"
                    @click="login">
                        交通项目
                    </a>
                </el-col>
                <el-col :span="12">
                    <a 
                    class="item slgc"
                    @click="login">
                        水利工程项目
                    </a>
                </el-col>
            </el-row>
            <el-row :gutter="10" style="margin-top:8px">
                <el-col :span="24">
                    <a 
                    class="item qycg"
                    @click="login">
                        企业采购项目
                    </a>
                </el-col>
               
            </el-row>

            <el-row :gutter="10" style="margin-top:8px">
                <el-col
                :span="24"
                >
                    <a 
                    class="item info"
                    href="/register"
                    target="_blank"
                    >
                        注册
                    </a>
                </el-col>
               
            </el-row>
                <!-- <el-col
                :span="24"
                >
                    <a 
                    class="item primary"
                    @click="login"
                    >
                        登录
                    </a>
                </el-col>
                <el-col
                :span="24"
                >
                    <a 
                    class="item info"
                    href="/register"
                    target="_blank"
                    >
                        注册
                    </a>
                </el-col> -->
      
            
        </div>

        
    </div>
</template>

<script>
import CONFIG from '@config/config';

import advBbJpg from '../assets/adv-bb.jpg';
import advCaJpg from '../assets/adv-ca.jpg';

import iconGuide from '../assets/icon/guide.png';
import iconTel from '../assets/icon/tel.png';

export default {
    data: () => ({
  
        guide: [
            {
                title: '关于我们',
                icon: iconGuide,
                url: '/about'
            },
            {
                title: '帮助中心',
                icon: iconTel,
                url: '/guide'
            }
        ],
        head:CONFIG.head,
    }),
    methods: {
        // 登录
        login() {
            window.open('/biddingWeb/pages/chooseusersub.html?indexUrl=' + window.btoa(window.location.href)+'&title=' + escape(this.head.title)+'&plan='+CONFIG.head.planname)
        },
        // 进场交易登录
        jcLogin(){
            window.open('http://www.hbidding.com/hbiddingWeb/pages/chooseusersub.html?indexUrl=' + window.btoa(window.location.href)+'&title=' + escape(this.head.title)+'&plan='+CONFIG.head.planname)
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '@css/var.scss';

    .enters{
        .lr{
            overflow: hidden;

            .item{
                display: block;
                width: 100%;
                box-sizing: border-box;
                float: left;
                font-size:16px;
                color: white;
                text-align: center;
                box-sizing: border-box;
                cursor: pointer;
                transition: all .3s;
                height: 56px;
                line-height: 56px;

                &.zfcg{
                    background:url(../assets/1.png)
                }
                &.gcjs{
                    background:url(../assets/2.png)
                }
                &.jtxm{
                    background:url(../assets/3.png)
                }
                &.slgc{
                    background:url(../assets/4.png)
                }
                &.qycg{
                    background:url(../assets/5.png)
                }

                &.info{
                    background: white;
                    color: #2252e7;
                    border:1px solid #2252e7;

                    &:hover{
                        background: #2252e7;
                        color: white;
                    }
                }
            }
        }


        
    }
</style>